const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'Oi',
    'Ref: Page content body':
      'Na chegada e partida, lembre -se de escanear seu barramento de código QR',
  },
};
export default labels;
